import { NgOptimizedImage } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { AnimatedButtonComponent } from '@components/animated-button/animated-button.component';
import { CardComponent } from '@components/card/card.component';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-health-labs-coupon',
  templateUrl: './health-labs-coupon.component.html',
  styleUrls: ['./health-labs-coupon.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CardComponent, AnimatedButtonComponent, NgOptimizedImage],
})
export class HealthLabsCouponComponent {
  /**
   * Returns the color for the HL CTA button.
   */
  public get buttonColor(): string {
    return environment.styles.healthLabsCoupon.buttonColor;
  }

  /**
   * It HL with the STDcheck order coupon
   */
  public redirectToHL() {
    window.open(
      'https://www.healthlabs.com/?coupon=15offstdcheckcustomer&utm_source=STDcheck_referral&utm_medium=link&utm_campaign=STDcheck_link',
      '_blank',
    );
  }
}
